export default __webpack_public_path__ + "static/media/communicate.fdbc3e4e.png";